import React from "react";

/** Sharp bento card with subtle honeycomb pattern in the corner. */
export function BentoCard({ children, className = "", accent = false, ...rest }) {
  return (
    <div
      className={`relative bg-white border-2 ${accent ? "border-yellow-500" : "border-black"} p-6 overflow-hidden ${className}`}
      {...rest}
    >
      <div className="absolute -right-6 -bottom-6 w-32 h-32 opacity-[0.05] bg-honeycomb-strong pointer-events-none" />
      <div className="relative">{children}</div>
    </div>
  );
}

export function StatCard({ label, value, sub, testid, icon: Icon }) {
  return (
    <BentoCard className="min-h-[140px]" data-testid={testid}>
      <div className="flex items-start justify-between">
        <span className="data-label">{label}</span>
        {Icon ? <Icon size={18} className="text-yellow-600" strokeWidth={2.25} /> : null}
      </div>
      <div className="mt-4 font-display text-4xl md:text-5xl font-bold tracking-tight text-black">
        {value}
      </div>
      {sub ? (
        <div className="mt-1 font-mono-data text-xs text-zinc-500 uppercase tracking-widest">
          {sub}
        </div>
      ) : null}
    </BentoCard>
  );
}

export function BrutalButton({ children, className = "", variant = "primary", as: Component = "button", ...rest }) {
  const base =
    "inline-flex items-center gap-2 px-4 py-2 font-display font-semibold text-sm border-2 border-black tracking-tight disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-yellow-400 text-black hover:bg-yellow-300 shadow-brutal-sm",
    secondary: "bg-white text-black hover:bg-zinc-50 shadow-brutal-sm",
    danger: "bg-red-500 text-white hover:bg-red-400 shadow-brutal-sm",
    ghost: "border-transparent bg-transparent hover:bg-zinc-100 shadow-none",
  };
  return (
    <Component className={`${base} ${variants[variant] || variants.primary} ${className}`} {...rest}>
      {children}
    </Component>
  );
}
